import { ThemeColorPalette } from "projects/shared/src/lib/style/configuration/theme-color-palette.interface";

export const AtrThemeColors: ThemeColorPalette = {
    primary: {
        50: '#FBF6FD',
        100: '#E5F5F3',
        200: '#D3B3DD',
        300: '#328C82',
        400: '#A766BB',
        500: '#2E8E83',
        600: '#48A99E',
        700: '#572666',
        800: '#3A1A44',
        900: '#1D0D22',
        background: '#EEF4F3',
        numpad: '#EEF4F3',
    },
    contrast: {
        50: '#F6FDFB',
        100: '#D2E7E0',
        200: '#A5CEC0',
        300: '#77B6A1',
        400: '#4A9D81',
        500: '#1D8562',
        600: '#145D45',
        700: '#0E4130',
        800: '#0A2E22',
        900: '#072018',
    },
    neutral: {
        50: '#FFFFFF',
        100: '#F5F5F5',
        200: '#E5E5E5',
        300: '#D4D4D4',
        400: '#A3A3A3',
        500: '#737373',
        600: '#525252',
        700: '#404040',
        800: '#262626',
        900: '#171717',
    },
    success: {
        50: '#EEFFEE',
        100: '#DFFFDF',
        200: '#9BD69B',
        300: '#74BF74',
        400: '#4DA753',
        500: '#419641',
        600: '#398836',
        700: '#357A2C',
        800: '#286A20',
        900: '#1D4D06',
    },
    warning: {
        50: '#FFF4F6',
        100: '#F5EDE4',
        200: '#EAD1AC',
        300: '#E4AD65',
        400: '#E69331',
        500: '#DB7800',
        600: '#D07100',
        700: '#C56B00',
        800: '#B76200',
        900: '#A15500',
    },
    danger: {
        50: '#FFF4F6',
        100: '#FAE5E5',
        200: '#F0CAC5',
        300: '#ED7B6C',
        400: '#D14F36',
        500: '#D14117',
        600: '#C23718',
        700: '#B12B12',
        800: '#A5260B',
        900: '#971D00',
    },
};
